import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Job Details</h3>
                <p className="text-sm text-gray-600">
                    Detailed management and progress tracking for an individual maintenance or service job.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Operational Tabs</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li><strong>Expenses:</strong> Log financial costs associated directly with this job.</li>
                    <li><strong>Users:</strong> Manage which team members are assigned to or involved in this task.</li>
                    <li><strong>Notes:</strong> Maintain a chronological log of updates, issues, or completion details.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Progress and Search</h4>
                <p className="text-sm text-gray-600">
                    Review job specifics in the header and use the search bar within each tab to find specific expenditures or notes as the job progresses.
                </p>
            </section>
        </div>
    );
};

export default Help;
